export default "__VITE_ASSET__DGipPBEH__"